import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { EUROPEAN_UNION_COUNTRY_CODES, NOT_ALLOWED_PATH } from '../shared/constants';
import { FlexRow, GridWrapper, NavBar, RootWrapper } from './styled';
import LogoutButton from '../Logout/LogoutButton';

export default function Auth0Layout({ allowNav = true, children }) {
  const countryData = useSelector((state) => state.externalSettings.ipAddressValidationData);
  const { user } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (countryData && EUROPEAN_UNION_COUNTRY_CODES.includes(countryData.countryCode)) {
      navigate(NOT_ALLOWED_PATH);
    }
  }, [countryData]);

  return (
    <RootWrapper>
      {allowNav && (
        <NavBar>
          <FlexRow>
            <Typography
              variant='body2'
              sx={{
                color: (theme) => theme.palette.common.white,
                marginRight: (theme) => theme.spacing(2),
                display: {
                  xs: 'none',
                  md: 'flex',
                }
              }}
            >
              Logged in as {user?.name}
            </Typography>
            <LogoutButton />
          </FlexRow>
        </NavBar>
      )}
      <GridWrapper
        container
        justifyContent="end"
        alignItems={allowNav ? 'flex-start' : 'center'}
        sx={{ minHeight: allowNav ? 'calc(100vh - 50px)' : '100vh' }}
      >
        <Grid id="main-section" item xs={12}>
          {children}
        </Grid>
      </GridWrapper>
    </RootWrapper>
  );
}

Auth0Layout.propTypes = {
  /**
   * The contained child react elements
   */
  allowNav: PropTypes.bool,
  children: PropTypes.node,
};

Auth0Layout.defaultProps = {
  allowNav: true,
  children: null,
};
